import React from 'react';
import useClaimTypes from '../components/hooks/useClaimTypes';
import { ClaimContext, ClaimState } from './ClaimContext';

type ClaimProviderProps = {
    children: React.ReactNode;
    initialState?: ClaimState;
};

const ClaimProvider = ({
    children,
    initialState
}: ClaimProviderProps): JSX.Element => {
    const {
        gapClaim,
        productReference,
        claimRequest,
        setGapClaim,
        setGapProductReference,
        setClaimRequest
    } = useClaimTypes(initialState);

    return (
        <ClaimContext.Provider
            value={{
                gapClaim,
                productReference,
                claimRequest,
                setGapClaim,
                setGapProductReference,
                setClaimRequest
            }}>
            {children}
        </ClaimContext.Provider>
    );
};

export default ClaimProvider;
